import React from 'react';
import { makeStyles } from '../styles';
const useStyles = makeStyles(() => ({
    root: {
        display: 'table',
        width: '100%',
        tableLayout: 'fixed',
    },
}));
export default ({ children }) => {
    const classes = useStyles();
    return React.createElement("thead", { className: classes.root }, children);
};
//# sourceMappingURL=THead.js.map